import { propertyListAction } from "../../../redux/slices/admin/admin-dashboard/propertyListSlice";
import { mapCreateUserApiUrl } from "../../for-service-provider/createUserApiPaths";

export const DEFAULT_VIEW_PROPERTY_CATEGORY = "complete_protection";

export const resolveViewPropertyCategory = (property) =>
  property?.product_tier || property?.category || DEFAULT_VIEW_PROPERTY_CATEGORY;

export const buildViewPropertyCacheKey = (propertyId, category) =>
  `${propertyId}:${category || DEFAULT_VIEW_PROPERTY_CATEGORY}`;

export const getCachedViewPropertyDetails = (
  cache,
  propertyId,
  category = DEFAULT_VIEW_PROPERTY_CATEGORY,
) => {
  if (!propertyId || !cache) {
    return null;
  }

  return cache[buildViewPropertyCacheKey(propertyId, category)] || null;
};

/**
 * Loads admin/view-property into Redux. Uses per-property cache unless refresh is requested.
 * @returns {{ fromCache: boolean, cacheKey: string }}
 */
export const fetchAdminViewPropertyDetails = (
  dispatch,
  property,
  viewPropertyDetailsCache = {},
  options = {},
) => {
  const propertyId = property?.id;
  const category = resolveViewPropertyCategory(property);
  const cacheKey = buildViewPropertyCacheKey(propertyId, category);
  const forceRefresh = Boolean(options.refresh);
  const isServiceProvider = Boolean(options.isServiceProvider);
  const userId = options.userId || null;

  if (!propertyId) {
    return { fromCache: false, cacheKey };
  }

  const cached = getCachedViewPropertyDetails(
    viewPropertyDetailsCache,
    propertyId,
    category,
  );

  if (!forceRefresh && cached?.success) {
    dispatch(propertyListAction.setAdminViewPropertyDetails(cached));
    return { fromCache: true, cacheKey };
  }

  dispatch(
    propertyListAction.getAdminViewPropertyDetails({
      url: mapCreateUserApiUrl(
        "admin/view-property",
        isServiceProvider,
        userId,
      ),
      data: {
        id: propertyId,
        category,
        ...(forceRefresh ? { refresh: true } : {}),
      },
      token: true,
    }),
  );

  return { fromCache: false, cacheKey };
};

export const invalidateViewPropertyDetailsCache = (dispatch, propertyId) => {
  if (!propertyId) {
    return;
  }

  dispatch(
    propertyListAction.clearViewPropertyDetailsCache({ propertyId }),
  );
};
